import React, { useState } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';

function Itinerary(props) {
  const [viewAllPorts, setViewAllPorts] = useState(false);
  const xsMedia = useMediaQuery('(max-width:640px)');
  const smMedia = useMediaQuery('(min-width:640px)');

  function handleSeeMoreChange() {
    debugger;
    setViewAllPorts(!viewAllPorts);
  }
  function FormatTime(timeString) {
    if (!timeString) {
      return "";
    }

    let pieces = timeString.split(":");
    return pieces[0] + ":" + pieces[1];
  }

  function SequenceName(seq) {
    if (seq < 0) {
      return "Pre cruise"
    }
    else if (seq > 0) {
      return "Post cruise"
    }
    else {
      return "Main cruise"
    }
  }

  function port(sequence, sp) {
    return (
      <div key={sequence + '_' + sp.sequence} className="table-row">
        <div className="table-cell px-4 align-top h-0">
          <div className="flex flex-col h-full">
            <div className="bg-black text-white p-3">
              {sequence}
            </div>
            <div className="w-1/2 h-full border-solid border-r-2 border-black" style={{ minHeight: 20 }} />
          </div>
        </div>
        <div className="table-cell align-top">
          <div className="text-lg font-semibold" >{sp.name}, {sp.country}</div>
          {sp.day == 1
            ?
            <div className="font-semibold">
              Departure: {props.cruisepackages.map((cp) =>
              new Intl.DateTimeFormat("en-GB", {
                day: "2-digit",
                month: "long"
              }).format(new Date(cp.departure)) + " | ")}
            </div>
            :
            <div></div>
          }
          <div dangerouslySetInnerHTML={{ __html: sp.shortDescription }} className="pb-4"></div>
        </div>
      </div >
    );
  }

  function gallery(gallery) {

    if (gallery.length > 0) {
      let accordionId = 1;

      return (
        <div>
          <h3 className="mt-3">Gallery</h3>

          {gallery.map((type) =>
            <div id={"galleryAccordion" + accordionId}>
              <div key={type.imageSubType}>
                <div className="col-12">
                  <h4><a className="card-link" data-toggle="collapse" href={"#collapse" + type.imageSubType}>{type.imageSubType}</a></h4>
                </div>
                <div id={"collapse" + type.imageSubType} className="collapse" data-parent={"#galleryAccordion" + accordionId++}>
                  {type.images.map((pic) =>
                    <React.Fragment>
                      <div className="my-3 row border-bottom">
                        <div className="col-12 col-sm-4 col-md-3 mb-3">
                          <img alt="gallery" src={pic.filePath} style={{ maxHeight: '300px', maxWidth: '300px', width: '100%' }} />
                        </div>
                        <div className="col-12 col-sm-8 col-md-9 mb-3">{pic.description}</div>
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }
  }

  {/*if (props.itineraries.length === 1) {
    return (
      <React.Fragment>
        {props.itineraries.map((it) =>
          <React.Fragment key={it.sequence}>
            {it.stopPoints.map((sp) => port(it, sp))}
          </React.Fragment>
        )
        }
      </React.Fragment>
    )
  }
  else {
    return (
      <React.Fragment>
        {props.itineraries.map((it) =>
          <div key={it.sequence} className="card my-3">
            <div className="card-header">{SequenceName(it.sequence)}</div>
            <div className="card-body">
              {it.stopPoints.map((sp) => port(it, sp))}
            </div>
          </div>
        )
        }
      </React.Fragment>
    )
  }*/}

  let stoppointNameList = "";
  const numberOfStoppoints = props.stopPoints.length;

  props.stopPoints.map((sp, index) => {
    stoppointNameList += sp.name;
    if (index < numberOfStoppoints - 1) {
      stoppointNameList += " - ";
    }
  });

  return (
    <React.Fragment>
      <div className="text-center py-3">
        <span className="text-xl font-semibold">Daily plan</span>
        <p className="text-lg mx-auto w-8/12">{stoppointNameList}</p>
      </div>
      <div style={xsMedia ? { maxHeight: 'calc(100vh - 170px' } : null}
        className="flex flex-col sm:flex-row overflow-auto sm:overflow-hidden">
        <div className="p-3 sm:w-1/3">
          <img src="/img/Barcelona_roundtrip.jpg" alt="Map" />
        </div>
        <div className="p-3 sm:w-2/3 sm:overflow-auto" style={smMedia ? { maxHeight: 'calc(100vh - 170px' } : null}>
          <div className="table">
            {
              props.stopPoints.map((sp, index) =>
                <React.Fragment key={index + "_wrapper"}>
                  {port(index + 1, sp)}
                </React.Fragment>
              )
            }
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Itinerary;